const TOGGLECARTHIDDEN = 'TOGGLE_CART_HIDDEN'
const ADDITEM = 'ADD_ITEM'
const CLEARITEM = 'CLEAR_ITEM'
const REMOVEITEM = 'REMOVE_ITEM'
const CLEARCART = 'CLEAR_CART'
export {
  TOGGLECARTHIDDEN,
  ADDITEM,
  CLEARITEM,
  REMOVEITEM,
  CLEARCART
}
